module.exports = __webpack_public_path__ + "img/A_action.8facf317.png";